import { AppRoutes } from "./routes/AppRoutes";

export const App = () => {
  return (
    <AppRoutes />
  );
}
